export default __webpack_public_path__ + "static/media/item-3.06935ffe.png";